import { CacheConfig, CacheStatus, getCachedItem, setCacheItem, setCacheStatus } from '@r-and-a-shared-ui/core-caching';
import { deliveryClient } from '../config/kontent-delivery-client';
import { adjustSystemProperties } from '../utils';
import { ApiConfig } from '../models/MEMBERSHIP/content-types/apiConfig';

export const getApiConfigByCodename = async (
  cache = true,
  cacheTTL = CacheConfig.TTL.ArticleAuthors.valueOf(),
  cacheStatus?: CacheStatus,
  codename?: string,
) => {
  try {
    const cacheKey = 'getApiConfigByCodename';
  
    const cachedItem = getCachedItem<ApiConfig[]>(cacheKey, cache);
  
    if (cachedItem) {
      setCacheStatus(cacheStatus, {
        cacheable: cache,
        xInMemoryCache: CacheConfig.Hit,
        cacheTTL
      });
      return {
        authors: cachedItem,
      };
    }
  
    const query = await deliveryClient
      .items<ApiConfig>()
      .type('api_config')
      .equalsFilter('system.codename', codename ?? '')
      .depthParameter(0)
      .toPromise();

    adjustSystemProperties(query.data.items);

    setCacheItem(cacheKey, query.data.items, cacheTTL, cache);

    setCacheStatus(cacheStatus, {
      cacheable: cache,
      xInMemoryCache: CacheConfig.Miss,
      cacheTTL
    });

    return {
      settings: query?.data?.items?.[0]?.elements || {}
    };
  } catch (error) {
    console.error('Error in getApiConfigByCodename', error);
    throw error;
  }
};
